import React, { useState, useEffect } from "react";
import { Box, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { styled } from "@mui/material/styles";

const ModalContainer = styled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "956px",
  height: "695px",
  backgroundColor: "#fff",
  borderRadius: "12px",
  boxShadow: "0 24px 48px rgba(0, 0, 0, 0.3)",
  outline: "none",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  "@media (max-width: 1360px)": {
    width: "706px",
    height: "519px",
  },
  "@media (max-width: 1360px)": {
    width: "361px",
    height: "323px",
  },
});

const ImageContainer = styled(Box)({
  flex: 1,
  position: "relative",
  padding: "32px",
  boxSizing: "border-box",
  "@media (max-width: 1360px)": {
    padding: "24px",
  },
  "@media (max-width: 856px)": {
    padding: "20px",
  },
});

const ImageWrapper = styled(Box)({
  width: "892px",
  height: "631px",
  overflow: "hidden",
  borderRadius: "8px",
  position: "relative",
  "@media (max-width: 1360px)": {
    width: "658px",
    height: "471px",
  },
  "@media (max-width: 856px)": {
    width: "321px",
    height: "283px",
  },
});

const FullscreenImage = styled("img")({
  width: "892px",
  height: "631px",
  //  objectFit: 'cover',
  objectPosition: "center",
  display: "block",
  borderRadius: "8px",
  "@media (max-width: 1360px)": {
    width: "658px",
    height: "471px",
  },
  "@media (max-width: 856px)": {
    width: "321px",
    height: "283px",
  },
});

const CloseButton = styled(IconButton)({
  position: "absolute",
  top: "10px",
  right: "10px",
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  color: "#666",
  width: "24px",
  height: "24px",
  zIndex: 10,
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 1)",
    color: "#333",
  },
  "@media (max-width: 1360px)": {
    top: "8px",
    right: "8px",
    width: "18px",
    height: "18px",
  },
  "@media (max-width: 856px)": {
    top: "6px",
    right: "6px",
    width: "14px",
    height: "14px",
  },
});

const NavigationButton = styled(IconButton)({
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  color: "#333",
  width: "34px",
  height: "34px",
  zIndex: 5,
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 1)",
  },
  "&:disabled": {
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    color: "#ccc",
  },
});

const FullscreenImagePopup = ({
  open,
  onClose,
  images,
  currentIndex,
  onPrevious,
  onNext,
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(currentIndex);
  useEffect(() => {
    setCurrentImageIndex(currentIndex);
  }, [currentIndex]);

  const handleFullscreenPrevious = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };
  const isPrevDisabled = currentImageIndex === 0;
  const isNextDisabled = currentImageIndex === images.length - 1;

  const handleFullscreenNext = () => {
    if (currentImageIndex < images.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="fullscreen-image-modal"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.3)",
      }}
    >
      <ModalContainer>
        <CloseButton onClick={onClose} aria-label="Close fullscreen view">
          <CloseIcon />
        </CloseButton>

        <ImageContainer>
          <ImageWrapper>
            <FullscreenImage
              src={images[currentImageIndex]}
              alt={`Product fullscreen view ${currentImageIndex + 1}`}
            />
          </ImageWrapper>

          {/* Navigation Arrows */}
          <NavigationButton
            onClick={handleFullscreenPrevious}
            disabled={isPrevDisabled}
            sx={{
              left: "40px",
              "@media (max-width: 1360px)": { left: "30px" },
            }}
            aria-label="Previous image"
          >
            <NavigateBeforeIcon />
          </NavigationButton>

          <NavigationButton
            onClick={handleFullscreenNext}
            disabled={isNextDisabled}
            sx={{
              right: "40px",
              "@media (max-width: 1360px)": { right: "30px" },
            }}
            aria-label="Next image"
          >
            <NavigateNextIcon />
          </NavigationButton>
        </ImageContainer>
      </ModalContainer>
    </Modal>
  );
};

export default FullscreenImagePopup;
